import { Component, Injector } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { UserRole } from '@models/user';
import { Analytics, ScreenTrackingService, setUserProperties } from '@angular/fire/analytics';
import { Performance } from '@angular/fire/performance';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectUser } from '@redux/index';
import { Auth0UserDetailDto } from '@services/api/api.service';
import { MatDialog } from '@angular/material/dialog';
import { GlobalAnnouncementModalComponent } from '@shared/components/global-announcement-modal/global-announcement-modal.component';
import { WebPushService } from '@services/web-push.service';

const GLOBAL_ANNOUNCEMENT_ENABLED = false;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        RouterOutlet,
    ]
})
export class AppComponent {
  private readonly globalAnnouncementId = '5.8.0';
  private globalAnnouncementChecked = false;
  user: Auth0UserDetailDto;


  constructor(
    screenTracking: ScreenTrackingService,
    private auth: AuthService,
    private store: Store,
    injector: Injector,
    private dialog: MatDialog,
    private webPush: WebPushService,
  ) {
    const performance = injector.get(Performance);

    console.log('performance', performance);
    performance.dataCollectionEnabled = true;



    this.store.select(selectUser).subscribe(user => {
      if (user) {
        this.user = user;
        if (GLOBAL_ANNOUNCEMENT_ENABLED) {
          this.checkAndShowGlobalAnnouncement();
        }
        if (!user.roles?.includes(UserRole.Customer)) {
          setUserProperties(injector.get(Analytics), {
            email: user?.email,
            name: user?.name,
            roles: user?.roles,
          });
        }
        void this.webPush.syncIfPermitted();
      }
    });
    // this.route.fragment.subscribe(url => {
    //   if (!this.user?.roles?.includes(UserRole.Customer)) {
    //     console.log('page_view', url);
    //     logEvent(window.analytics, 'page_view', {
    //       url: url.join('/'),
    //     });
    //   }
    // });
  }

  private checkAndShowGlobalAnnouncement(): void {
    if (this.globalAnnouncementChecked) {
      return;
    }

    this.globalAnnouncementChecked = true;
    const storageKey = `globalAnnouncementSeen:${this.globalAnnouncementId}`;
    if (localStorage.getItem(storageKey)) {
      return;
    }

    this.dialog.open(GlobalAnnouncementModalComponent, {
      data: { storageKey },
      disableClose: true,
      panelClass: 'global-announcement-modal-panel',
      width: '600px',
      maxWidth: '90vw',
    });
  }
}
